<template>
  <el-row class="order">
    <el-col :span="24">
      <el-input
        v-model="keyword"
        placeholder="订单号、商品名、收件人、手机号"
        prefix-icon="el-icon-search"
        @input="refresh"
        clearable
        size="small"
        style="width:260px">
      </el-input>
      <el-select
        v-model="partnerId"
        placeholder="选择机构"
        @change="refresh"
        clearable
        style="width:140px">
        <el-option
        v-for="(item,index) in partnerList"
        :key="index"
        :label="item.title"
        :value="item.id">
      </el-option>
    </el-select>
      <el-button icon="el-icon-refresh" @click="refresh" size="small" type="primary">刷新</el-button>
    </el-col>
    <el-col :span="24" style="margin-top:10px">
      <el-tabs value="all" @tab-click="clickHandle">
        <el-tab-pane :label="'全部（'+dataList['all'].total+'）'" name="all">
          <order-item
            :data="dataList['all']"
            key="all"
            @action-success="refresh"
            @currentChange="currentChange($event,'all')">
          </order-item>
        </el-tab-pane>
      </el-tabs>
    </el-col>
  </el-row>
</template>
<script>
import '@/components/AddressSelect/index'
import '@/components/EditLayer/index'
import OrderItem from './components/orderItem'
import request from '@/utils/request'
export default {
  name: 'OrderList',
  components: {
    OrderItem
  },
  data () {
    return {
      visible: false,
      time: [],
      keyword: '',
      dataList: {
        freight_pending: {},
        pay_pending: {},
        freighted: {},
        aftersale_pending: {},
        all: {}
      },
      activeTab: 'all',
      per_page: 4,
      statusKeys: ['all'],
      partnerId: null,
      partnerList: []
    }
  },
  created () {
    this.init()
    this.getPartners()
  },
  methods: {
    getPartners () {
      request({
        url: '/partners',
        params: {
          page: this.page,
          per_page: this.per_page
        }
      }).then(res => {
        this.partnerList = res.data.list
      })
    },
    init () {
      let statusKeys = this.statusKeys
      for (let i = 0; i < statusKeys.length; i++) {
        this.dataList[statusKeys[i]] = {
          page: 1,
          list: [],
          per_page: this.per_page,
          total: 0,
          status: statusKeys[i]
        }
      }
      // 商品列表
      // this.getOrderList('freight_pending') // 待发货
      // this.getOrderList('pay_pending') // 待付款
      // this.getOrderList('freighted') // 已发货
      // this.getOrderList('aftersale_pending') // 售后中
      this.getOrderList('all').then(res => {
        // this.$store.dispatch('getUnread').then(() => {})
      }) // 全部
    },
    clickHandle (tab) {
      this.activeTab = tab.name
    },
    getOrderList (status) {
      return new Promise((resolve, reject) => {
        let sendData = {
          status: status,
          key: this.keyword,
          per_page: this.per_page,
          page: this.dataList[status].page,
          partner_id: this.partnerId
        }
        request({
          url: 'partner-vip-orders',
          method: 'get',
          params: sendData
        }).then(res => {
          resolve()
          this.dataList[status].list = res.data.list
          this.dataList[status].total = res.data.item_total
        }).catch(err => {
          reject(err)
        })
      })
    },
    currentChange (e, status) {
      this.dataList[status].page = e
      this.getOrderList(status)
    },
    refresh (status) {
      // this.getOrderList('freight_pending') // 待发货
      // this.getOrderList('pay_pending') // 待付款
      // this.getOrderList('freighted') // 已发货
      // this.getOrderList('aftersale_pending') // 售后中
      this.getOrderList('all').then(res => {
        // this.$store.dispatch('getUnread').then(() => {})
      }) // 全部
    }
  }
}
</script>
<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/views/partnerVip/order.vue